export const TRANSACTION_CODES = {
  1: "Deposit with credit",
  2: "Deposit",
  3: "Deposit",
  4: "Deposit from balance",
  5: "Withdrawal",
  6: "Withdrawal",
  7: "Withdrawal to balance",
  8: "Session credit transfer to balance",
  9: "Session credit transfer to balance",
  11: "Clear session credit ",
  10: "Clear session credit ",
  12: "Clear session credit ",
  13: "Clear session credit with balance",
  14: "Clear Balance",
  15: "Clear Balance",
  16: "Clear Balance",
  17: "Balance withdrawal",
  18: "Balance withdrawal",
  19: "Bonus",
  20: "Bonus",
  21: "Rake",
  22: "Tip",
  23: "Bad Beat",
  24: "Dealer withdrawal",
  25: "Service Staff Credit",
  26: "Service Staff payment",
  27: "Service Staff payment",
  28: "Service Staff withdrawal",
  29: "Service Staff withdrawal",
  30: "P2P receiver",
  31: "P2P sender",
  32: "Cost",
  33: "Cash bag refill",
  34: "Cash bag verification",
  35: "Clear cash bag",
  36: "Wallet transfer",
  37: "Cash bag reset"
};

export const DEPOSIT_CODES = [1, 2, 3, 4, 19, 30];
export const WITHDRAWAL_CODES = [5, 6, 7, 12, 16, 17, 18, 31];
export const BOOK_CODES = [1, 4, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20, 30, 31];
export const RAKE_CODES = [21];
export const TIP_CODES = [22];
export const BONUS_CODES = [19, 20];
export const DEALER_PAYOUT_CODES = [24];
export const WALLET_DECREASE_CODES = [3, 10, 14, 26];
export const WALLET_INCREASE_CODES = [6, 17, 28];



export const formatTransactionCode = (code, fallbackType = null, fallbackMethod = null) => {
  if (code && TRANSACTION_CODES[code]) {
    return TRANSACTION_CODES[code];
  }

  // Handle legacy or non-code transactions gracefully
  if (fallbackType) {
    let desc = fallbackType.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
    if (fallbackMethod) {
      desc += ` (${fallbackMethod})`;
    }
    return desc;
  }
  
  return "Unknown Transaction";
};
